import axios from "axios";
import api from "@/api/api";
import AES from "@/mixins/AES";

let Language = [];
const getLanguage = () => {
  if (window.localStorage.getItem("language")) {
    Language = JSON.parse(AES.decrypt(window.localStorage.getItem("language")));
  } else {
    axios
      .post(api + "/api/Common/GetSystemLanguage")
      .then((res) => {
        console.log(res.data.data);
        let item = res.data.data.find((v) => v.code == "zh_CN");
        item.code = "zh";

        Language = res.data.data;
        window.localStorage.setItem(
          "language",
          AES.encrypt(JSON.stringify(Language))
        );
      });
  }

  console.log(Language);
};

getLanguage();

export { Language };
